<template>
  <div id='orderdetail'>
        <NavTop title='订单详情'/>
        <div class="orderinfo">
        <div class="addresscon">
           <div class="addresscon-line1">
               <div class="location-icon"><van-icon name="location-o" /></div>
               <div class="location-address">{{item.province+item.city+item.county+item.address}}</div>
           </div>
           <div class="addresscon-line2">
               {{item.name}}{{item.mobile}}
           </div>
        </div>   
        <OrderItem 
          :orderinfo="orderinfo"
          :ordergoods="ordergoods"
        />
        </div>
        <van-submit-bar :price="item.realmoney*100" >
         <template #button>
            <div class="bottomcon-btn-cancel" @click="onCancel" v-if="item.status==1">取消订单</div>
            <div class="bottomcon-btn-sure" @click="onSubmit" v-if="item.status==1">去付款</div>
         </template>
    </van-submit-bar>   
  </div>
</template>
<script>
import {SubmitBar,Icon} from 'vant';
import NavTop from '@/components/navtop'
import OrderItem from '@/components/orderitem'

export default {
   name: 'orderdetail',
   data() {
      return {
         item:{},
         orderinfo:{},
         ordergoods:[]
      }
   }, 
   created(){
      this.getList()
   },
   methods: {
      getList(){ 
           this.$post("/order/getOrderDetail",{orderid:this.$route.params.orderid}).then((data)=>{
               if(data.result.success){
                  this.item=data.result.info
                  this.orderinfo=data.result.info.orderinfo
                  this.ordergoods=data.result.info.ordergoods
               }else{
                  this.$toast(data.result.info)
               }
           })
      },
      onSubmit(){
          this.$go('/payment/'+this.orderinfo.id)
      },
      onCancel(){
          this.$post("/order/cancelOrder",{orderid:this.$route.params.orderid}).then((data)=>{
              if(data.result.success){
                  this.$toast(data.result.info)
                  setTimeout(()=>{this.$go("/orderlist")},1000)
              }else{
                  this.$toast(data.result.info)
              }
          })
      }
   },
   components: {
        [SubmitBar.name]:SubmitBar,
        [Icon.name]:Icon,
        NavTop,OrderItem
   }
}
</script>
<style scoped>
#orderdetail{background-color:#F6F6F6;min-height: 100vh;padding-bottom: 85px;}
.orderinfo{padding: 0.25rem;}
.bottomcon-btn-cancel{background-color:#ccc;color:#333;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-right: 0.1rem;}
.bottomcon-btn-sure{background-color:#ee0a24;color:#fff;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.addresscon{display: flex;flex-flow: column nowrap;background-color: #fff;border-radius: 0.1rem;margin-bottom: 0.25rem;padding: 0.3rem;}
.addresscon-line1{display: flex;flex-flow: row nowrap;padding: 0.1rem;align-items: center;}
.location-address{font-size:0.35rem;color:#333;}
.addresscon-line2{text-align: left;font-size:0.35rem;color:#333;padding: 0.1rem;}
</style>